import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './routes'

// 使用 hash 路由，部署到普通静态服务器时不需要额外配置后端重写。
const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
    // 每次切换页面后滚动到顶部。
    scrollBehavior() {
        return {
            top: 0,
        }
    },
})

export default router
